<template>
	<div>
		<v-flex xs7 ml-5 mt-4>
			<v-layout wrap>
				<span class="grey--text text--darken-2 caption font-weight-bold uppercase mb-1">Compras</span>

				<v-flex xs12 mb-4>
					<v-select
						background-color="white"
						box
						multiple
						chips
						deletable-chips
						clearable
						class="body-1"
						hide-details
						item-text="name"
						item-value="id"
						label="Tipo de Pago para Compras"
						:items="typePaymentMethods"
						v-model="typePaymentPurchases"
						@change="emitChange('codePurchase', $event)"
					></v-select>
				</v-flex>
			</v-layout>
			<v-layout wrap>
				<span class="grey--text text--darken-2 caption font-weight-bold uppercase mb-1">Ventas</span>

				<v-flex xs12 mb-4>
					<v-select
						background-color="white"
						box
						multiple
						chips
						deletable-chips
						clearable
						class="body-1"
						hide-details
						item-text="name"
						item-value="id"
						label="Tipo de Pago para Ventas"
						:items="typePaymentMethods"
						v-model="typePaymentSales"
						@change="emitChange('codeSales', $event)"
					></v-select>
				</v-flex>
			</v-layout>
		</v-flex>
	</div>
</template>
<script>

export default {
	name: 'configuration-payment-methods',
	props: {
		data: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			typePaymentPurchases: [],
			typePaymentSales: [],
			typePaymentMethods: [
				{ id: 'efectivo', name: 'Efectivo' },
				{ id: 'deposito-bancario', name: 'Depósito Bancario' },
				{ id: 'yape', name: 'Yape' },
				{ id: 'plin', name: 'Plin' },
				{ id: 'niubiz', name: 'Niubiz' },
				{ id: 'izipay', name: 'Izipay' },
				{ id: 'vendemas', name: 'Vendemas' }
			]
		};
	},
	created() {
		if (this.data && this.data.items.data.settings) {
			this.typePaymentPurchases = this.data.items.data.settings.typePaymentsInit.codePurchase || [];
			this.typePaymentSales = this.data.items.data.settings.typePaymentsInit.codeSales || [];
		}
	},
	methods: {
		emitChange(key, value) {
			this.$emit('update-settings', { key, value });
		}
	},
	watch: {
		data: {
			handler(newVal) {
				if (
					newVal &&
					newVal.items &&
					newVal.items.data &&
					newVal.items.data.settings &&
					newVal.items.data.settings.typePaymentsInit
				) {
					const settings = newVal.items.data.settings.typePaymentsInit;
					const newPurchases = settings.codePurchase || [];
					const newSales = settings.codeSales || [];

					if (JSON.stringify(this.typePaymentPurchases) !== JSON.stringify(newPurchases)) {
                        this.typePaymentPurchases = newPurchases;
                    }
                    if (JSON.stringify(this.typePaymentSales) !== JSON.stringify(newSales)) {
                        this.typePaymentSales = newSales;
                    }
				}
			},
			deep: true
		}
	}
};
</script>

<style scoped>
span {
	font-size: 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration-general/configuration-payment-methods.vue